import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { PageContext } from '../components/page';
import PageContentWrapper from '../components/pageContentWrapper';
import { FlightViewBody } from './FlightViewBody';
import { getFlight } from '../../service/flightService';
import { ProcessedFlightHistory } from '../../types/flight';

const ViewFlightContainer: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [flightData, setFlightData] = useState<ProcessedFlightHistory | null>(null);
  const { flightId } = useParams();
  const { pushAlert } = useContext(PageContext);

  useEffect(() => {
    const fetchFlightData = async () => {
      setLoading(true);
      try {
        if (flightId) {
          const response = await getFlight(flightId);
          setFlightData(response);
        }
      } catch (error) {
        pushAlert('danger', `Something went wrong retrieving flightId: '${flightId}'`);
      } finally {
        setLoading(false);
      }
    };

    fetchFlightData();
  }, [flightId, pushAlert]);

  return (
    <PageContentWrapper loading={loading} title="VIEW FLIGHT">
      <FlightViewBody flightData={flightData} />
    </PageContentWrapper>
  );
};

export default ViewFlightContainer;